module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', {
    attrs: {
      "body-padding-bottom": "111px"
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("尊敬的"), _c('a', [_vm._v(_vm._s(_vm.holderName))]), _vm._v("先生/女士，您好。感谢您选择了横琴人寿的横琴优康保终身重大疾病保险产品，为保障您的权益，请您详细阅读并确认下列问题：")]), _vm._v(" "), _c('ul', {
    staticClass: "notifies"
  }, [_c('li', [_vm._v("1. "), _c('a', [_vm._v(_vm._s(_vm.date))]), _vm._v("，在我公司投保了"), _c('a', [_vm._v("1")]), _vm._v("份横琴优康宝终身重大疾病保险，首期共缴纳了保费"), _c('a', [_vm._v(_vm._s(_vm.premium))]), _vm._v("元，连续缴"), _c('a', [_vm._v(_vm._s(_vm.insurePayWay))]), _vm._v("年（期缴），为您提供的保障期限是终身，请问您是否清楚？")]), _vm._v(" "), _c('li', [_vm._v("2. 电子保单已经发送给您，请您登陆投保时所留电子邮箱进行查收。")]), _vm._v(" "), _c('li', [_vm._v("3. 您是否已经阅读过产品的保险条款、投保提示书并且清楚产品的保险责任和责任免除，请您确认。")]), _vm._v(" "), _c('li', [_vm._v("4. 从签收电子保险合同次日开始算起的15个自然日是犹豫期，犹豫期内您可以无条件解除保险合同，公司将全额退还您所交的保费；如果超过犹豫期且合同未满期，解除保险合同可能会有一定损失，请问您是否清楚？")]), _vm._v(" "), _c('li', [_vm._v("5. 为了保持与您的联系，请您核对一下您的联系电话："), _c('a', [_vm._v(_vm._s(_vm.holderPhone))]), _vm._v("，通信地址："), _c('a', [_vm._v(_vm._s(_vm.holderAddress))]), _vm._v("，请您确认。")]), _vm._v(" "), (_vm.hq) ? _c('li', [_vm._v("6. 如果您在回访问卷中点选为“否”或未进行在线回访，保险公司的客服将以电话方式再次和您确认回访内容，来电号码为0756-6997966，请保持手机畅通。")]) : _vm._e()]), _vm._v(" "), (_vm.needIDCard) ? _c('div', [_c('p', {
    staticClass: "tip"
  }, [_vm._v("根据国家反洗钱法规定，您必须上传投保人身份证正反面")]), _vm._v(" "), _c('VueImgInputer', {
    staticStyle: {
      "display": "block",
      "margin": "0 auto",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": "上传身份证正面照片",
      "imgSrc": _vm.positivePicSrc,
      "theme": "light",
      "accept": "image/*",
      "capture": false
    },
    model: {
      value: (_vm.positivePicValue),
      callback: function($$v) {
        _vm.positivePicValue = $$v
      },
      expression: "positivePicValue"
    }
  }), _vm._v(" "), _c('VueImgInputer', {
    staticStyle: {
      "display": "block",
      "margin": "0 auto"
    },
    attrs: {
      "placeholder": "上传身份证反面照片",
      "imgSrc": _vm.negativePicSrc,
      "theme": "light",
      "accept": "image/*",
      "capture": false
    },
    model: {
      value: (_vm.negativePicValue),
      callback: function($$v) {
        _vm.negativePicValue = $$v
      },
      expression: "negativePicValue"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('tabbar', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('span', {
    class: {
      active: _vm.confirmFeedback === true, 'theme-bg-color': _vm.confirmFeedback === true, 'border-theme-color': _vm.confirmFeedback === true
    },
    on: {
      "click": function($event) {
        _vm.changeFeedback(true)
      }
    }
  }, [_vm._v("是，我已全部确认")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.confirmFeedback === false, 'theme-bg-color': _vm.confirmFeedback === false, 'border-theme-color': _vm.confirmFeedback === false
    },
    on: {
      "click": function($event) {
        _vm.changeFeedback(false)
      }
    }
  }, [_vm._v("否，我需要电话回访")])]), _vm._v(" "), _c('div', {
    staticClass: "next theme-bg-color",
    on: {
      "click": _vm.next
    }
  }, [_c('span', [_vm._v("确认提交")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0909bbd0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feedback.vue
// module id = 650
// module chunks = 1